module.exports = __webpack_public_path__ + "media/social/link-mail@3x-4706f145.svg";